<template>
  <div class="my-container">
    <el-row>
      <el-col :span="16">
        <el-row class="tcf-row" style="padding-right: 10px;padding-bottom: 0;">
          <el-col :span="24" class="card">
            <div class="card-body">
              <div class="card-content">
                <el-row>
                  <el-col :span="8">
                    <router-link :to="user.rank===0?'/my/info':'/my/dealerinfo'">
                      <div class="user-info">
                        <el-avatar :size="80" :src="user.rank===0?user.dPhoto:user.photo"></el-avatar>
                        <div class="name">{{user.rank===0?user.dName:user.name}}<svg-icon icon-class="group" v-if="user.rank===0"/><span>{{user.rank===0?user.group_abbname:''}}</span></div>
                        <div class="dept" v-if="user.rank===0">{{user.dept_name}} / {{user.position_name}}</div>
                        <div class="dept" v-if="user.rank===1">{{user.delname}}</div>
                        <div class="edit"><i class="el-icon-edit-outline"></i> 编辑资料</div>
                      </div>
                    </router-link>
                  </el-col>
                  <el-col :span="8">
                    <div class="box" style="border-left: 1px solid #f5f7fa;border-right: 1px solid #f5f7fa;">
                      <div class="txt">累计学时</div>
                      <div class="val">
                        <countTo :startVal="0" :endVal="period/3600" :separator="''" :duration="3000"/>
                        <span class="unit">小时</span>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="box">
                      <div class="txt">剩余积分</div>
                      <div class="val"><countTo :startVal="0" :endVal="integral" :separator="''" :duration="3000"/></div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-col>
          <el-col :span="24" class="card">
            <div class="card-body">
              <div class="card-content">
                <el-tabs>
                  <el-tab-pane label="我的积分">
                    <el-row>
                      <el-col :span="6">
                        <ul class="filter">
                          <li :class="integralFilter===0?'active':''" @click="getIntegralData(0)">全部</li>
                          <li :class="integralFilter===1?'active':''" @click="getIntegralData(1)">收入</li>
                          <li :class="integralFilter===2?'active':''" @click="getIntegralData(2)">支出</li>
                        </ul>
                      </el-col>
                      <el-col :span="18" v-loading="integralLoading">
                        <ul class="integral-list">
                          <li v-for="d in integralData">
                            <div class="remark">{{d.remark}}</div>
                            <div class="time">{{d.time}}</div>
                            <div :class="d.type===1?'num':'num less'">{{d.type===1?'+':'-'}}{{d.integral}}</div>
                          </li>
                        </ul>
                        <el-pagination
                          v-if="integralTotal>0"
                          background
                          :current-page="integralCurrentPage"
                          :page-size="5"
                          :pager-count="5"
                          @current-change="integralHandleCurrentChange"
                          layout="total, prev, pager, next, jumper"
                          :total="integralTotal">
                        </el-pagination>
                      </el-col>
                    </el-row>
                  </el-tab-pane>
                  <el-tab-pane label="我的学习" v-loading="courseLoading">
                    <ul class="course-list">
                      <li v-for="course in courseData" @click="goCourseDetail(course)">
                        <div class="course-img" :style="'background-image:url('+course.img_url+')'"></div>
                        <div class="course-info">
                          <div class="course-name">{{course.course_name}}</div>
                          <div class="course-chapter">{{course.chapter_name}}</div>
                          <div class="course-cache">学习至<span class="val">{{course.percent}}</span>%</div>
                        </div>
                      </li>
                    </ul>
                    <el-pagination
                      v-if="courseTotal>0"
                      background
                      :current-page="courseCurrentPage"
                      :page-size="5"
                      :pager-count="5"
                      @current-change="courseHandleCurrentChange"
                      layout="total, prev, pager, next, jumper"
                      :total="courseTotal">
                    </el-pagination>
                  </el-tab-pane>
                  <el-tab-pane label="我的收藏" v-loading="collectLoading">
                    <el-row>
                      <el-col :span="6">
                        <ul class="filter">
                          <li :class="collectFilter===1?'active':''" @click="getCollectData(1)">课程</li>
                          <li :class="collectFilter===2?'active':''" @click="getCollectData(2)">资讯</li>
<!--                          <li :class="collectFilter===3?'active':''" @click="getCollectData(3)">展厅</li>-->
<!--                          <li :class="collectFilter===4?'active':''" @click="getCollectData(4)">案例</li>-->
                          <li :class="collectFilter===5?'active':''" @click="getCollectData(5)">智享库</li>
                        </ul>
                      </el-col>
                      <el-col :span="18">
                        <ul class="collect-list">
                          <li v-for="collect in collectData">
                            <div class="collect-img" :style="'background-image:url('+collect.img_url+')'" @click="goCollect(collect)"></div>
                            <div class="collect-info">
                              <div class="collect-name" @click="goCollect(collect)">{{collect.name}}</div>
                              <div class="collect-desc" @click="goCollect(collect)">
                                <span v-if="collect.type===1||collect.type===3||collect.type===4">{{collect.course_two}}/{{collect.course_thr}}</span>
                                <span v-if="collect.type===5" class="tag"><i class="el-icon-share"/>
                                  <span v-if="collect.course_two===null||collect.course_two===''">Elichain</span>
                                  <span v-if="collect.course_two!==null&&collect.course_two!==''">{{collect.course_two}}</span>
                                </span>
                                <span v-if="collect.type===2||collect.type===5" class="tag"><i class="el-icon-time"></i> {{collect.add_time}}</span>
                                <span v-if="collect.type===2||collect.type===5" class="tag"><i class="el-icon-view"></i> {{collect.views}}</span>
                              </div>
                              <el-button size="small" round @click.native="cannelCollect(collect.type,collect.data_id)">取消收藏</el-button>
                            </div>
                          </li>
                        </ul>
                        <el-pagination
                          v-if="collectTotal>0"
                          background
                          :current-page="collectCurrentPage"
                          :page-size="5"
                          :pager-count="5"
                          @current-change="collectHandleCurrentChange"
                          layout="total, prev, pager, next, jumper"
                          :total="collectTotal">
                        </el-pagination>
                      </el-col>
                    </el-row>
                  </el-tab-pane>
                  <el-tab-pane label="兑换记录" v-loading="changeLoading">
                    <el-col :span="24">
                      <el-table
                        :data="changeData"
                        :show-header="false"
                        style="width: 100%">
                        <el-table-column
                          label="#"
                          width="200">
                          <template slot-scope="scope">
                            <el-image :src="scope.row.imgurl" fit="cover" :preview-src-list="[scope.row.imgurl]"/>
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="商品名称"
                          prop="goodsname"
                          width="140">
                        </el-table-column>
                        <el-table-column
                          label="积分"
                          prop="spend"
                          width="140">
                          <template slot-scope="scope">
                            <span><i class="el-icon-coin"/>{{scope.row.spend}}</span>
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="兑换方式"
                          prop="receive"
                          width="140">
                          <template slot-scope="scope">
                            <span v-if="scope.row.receive===0">邮寄</span>
                            <span v-if="scope.row.receive===1">兑换码</span>
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="兑换时间"
                          prop="time"
                          width="140">
                        </el-table-column>
                        <el-table-column
                          label="兑换时间"
                          prop="mark"
                          width="140">
                          <template slot-scope="scope">
                            <span v-if="scope.row.mark===0">未处理</span>
                            <span v-if="scope.row.mark===1">已处理</span>
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="处理时间"
                          prop="opertime"
                          width="140">
                          <template slot-scope="scope">
                            <span v-if="scope.row.opertime===''">处理时间：暂无</span>
                            <span v-if="scope.row.opertime!==''">处理时间：{{scope.row.opertime}}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-col>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="8">
        <el-row class="tcf-row" style="padding-left: 10px;padding-bottom: 0;">
          <el-col :span="24" class="card">
            <div class="card-body">
              <div class="card-title">
                热门兑换
                <router-link to="/my/integral_center"><el-button type="text" class="right">积分中心</el-button></router-link>
              </div>
              <div class="card-content">
                <el-carousel v-if="integralLottery.length>0" class="integral-lottery" height="120px" :interval="5000" indicator-position="none">
                  <el-carousel-item v-for="il in integralLottery">
                    <div class="banner-item" :style="'background-image:url('+il.img_url+')'"></div>
                  </el-carousel-item>
                </el-carousel>
                <ul class="goods-list">
                  <li v-for="goods in goodsData">
                    <router-link :to="{path:'/my/goods_detail/'+goods.goods_id}">
                      <div class="goods-img" :style="'background-image: url('+goods.img_url+')'"></div>
                      <div class="goods-name">{{goods.goods_name}}</div>
                      <div class="goods-desc">{{goods.all_name}}</div>
                      <div class="goods-price">{{goods.price}}<span>积分</span></div>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import countTo from 'vue-count-to'
import { getUserIntegralList, getUserInfo, getUserStudyList, getUserCollect, collectNews, getLottery, getLotteryItem, getGoodsList } from '@/api/my/index'
import { userChangeList } from '@/api/my'

export default {
  name: 'my',
  components: {
    countTo
  },
  computed: {
    user: getUser
  },
  data() {
    return {
      period: 0,
      integral: 0,
      integralFilter: 0,
      integralData: [],
      integralCurrentPage: 1,
      integralTotal: 0,
      integralLoading: false,
      courseData: [],
      courseCurrentPage: 1,
      courseTotal: 0,
      courseLoading: false,
      collectFilter: 1,
      collectData: [],
      collectCurrentPage: 1,
      collectTotal: 0,
      collectLoading: false,
      goodsData: [],
      integralLottery: [],
      changeLoading: false,
      changeData: [],
      changeCurrentPage: 1,
      changeTotal: 0
    }
  },
  created() {
    this.period = this.user.rank === 0 ? this.user.dPeriod : this.user.period
    this.integral = this.user.rank === 0 ? this.user.dIntegral : this.user.integral
    this.getUserInfoData()
    this.getIntegralData(this.integralFilter)
    this.getCourseData()
    this.getCollectData(1)
    this.getGoodsData()
    this.getUserChangeList()
  },
  watch: {
    $route(to, from) {
      if (to.path === '/my') {
        this.getUserInfoData()
      }
    }
  },
  methods: {
    getUserInfoData() {
      let _username = null
      if (this.user.rank === 0) {
        _username = this.user.dUsername
      } else {
        _username = this.user.username
      }
      getUserInfo({ username: _username, role: this.user.rank }).then(response => {
        if (this.user.rank === 0) {
          this.period = response.data.dPeriod
          this.integral = response.data.dIntegral
        } else {
          this.period = response.data.period
          this.integral = response.data.integral
        }
      })
    },
    getIntegralData(type) {
      this.integralLoading = true
      this.integralFilter = type
      let _userid = null
      if (this.user.rank === 0) {
        _userid = this.user.dUserid
      } else {
        _userid = this.user.userid
      }
      const data = {
        type: this.integralFilter,
        page: this.integralCurrentPage,
        limit: 5,
        userid: _userid,
        role: this.user.rank,
        mark: 1
      }
      const _this = this
      getUserIntegralList(data).then(response => {
        _this.integralData = response.data.list
        _this.integralTotal = response.data.total
        _this.integralLoading = false
      })
    },
    getCourseData() {
      let _userid = null
      if (this.user.rank === 0) {
        _userid = this.user.dUserid
      } else {
        _userid = this.user.userid
      }
      const data = {
        userid: _userid,
        role: this.user.rank,
        page: this.courseCurrentPage,
        limit: 5,
        mark: 1
      }
      const _this = this
      _this.courseLoading = true
      getUserStudyList(data).then(response => {
        _this.courseData = response.data.list
        _this.courseTotal = response.data.total
        _this.courseLoading = false
      })
    },
    getCollectData(n) {
      this.collectFilter = n
      const _this = this
      this.collectLoading = true
      let _userid = null
      if (this.user.rank === 0) {
        _userid = this.user.dUserid
      } else {
        _userid = this.user.userid
      }
      const data = {
        type: n,
        mark: 1,
        userid: _userid,
        role: this.user.rank,
        page: _this.collectCurrentPage,
        limit: 5
      }
      getUserCollect(data).then(response => {
        _this.collectTotal = response.data.total
        _this.collectData = response.data.list
        _this.collectLoading = false
      })
    },
    getGoodsData() {
      getLottery().then(response => {
        this.integralLottery = response.data
      })
      getGoodsList({ type: 1, page: 1, limit: 5 }).then(response => {
        this.goodsData = response.data
      })
    },
    integralHandleCurrentChange(val) {
      this.integralCurrentPage = val
      this.getIntegralData(this.integralFilter)
    },
    courseHandleCurrentChange(val) {
      this.courseCurrentPage = val
      this.getCourseData()
    },
    collectHandleCurrentChange(val) {
      this.collectCurrentPage = val
      this.getCollectData(this.collectFilter)
    },
    cannelCollect(type, dataId) {
      this.$confirm('您确定将它从您的收藏中拿走吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let _userid = null
        if (this.user.rank === 0) {
          _userid = this.user.dUserid
        } else {
          _userid = this.user.userid
        }
        const data = {
          type: type,
          dataId: dataId,
          userId: _userid,
          role: this.user.rank,
          mark: 1
        }
        collectNews(data).then(response => {
          if (response.success) {
            this.$message({
              message: '取消收藏成功',
              type: 'success'
            })
            this.getCollectData(type)
          }
        })
      })
    },
    goCourseDetail(course) {
      this.$router.push({
        path: '/study/course_detail/' + course.course_id,
        query: {
          chid: course.chapter_id
        }
      })
    },
    goCollect(collect) {
      if (collect.type === 1) {
        this.$router.push({
          path: '/study/course_detail/' + collect.data_id
        })
      }
      if (collect.type === 2) {
        this.$router.push({
          path: '/news/news_detail/' + collect.data_id
        })
      }
      if (collect.type === 3 || collect.type === 4) {
        this.$router.push({
          path: '/about/hallCase_detail/' + collect.data_id
        })
      }
      if (collect.type === 5) {
        this.$router.push({
          path: '/study/sharedata_detail/' + collect.data_id
        })
      }
    },
    getUserChangeList() {
      let _userid = null
      if (this.user.rank === 0) {
        _userid = this.user.dUserid
      } else {
        _userid = this.user.userid
      }
      userChangeList({ userid: _userid, role: this.user.rank, page: this.changeCurrentPage, limit: 6 }).then(response => {
        this.changeData = response.data
        this.changeTotal = response.total
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.my-container {
  .tcf-row{
    .card{
      margin-bottom: 20px;
      .card-body{
        .card-content{
          .user-info{
            width: 100%;
            position: relative;
            padding-left: 90px;
            cursor: pointer;
            .el-avatar{
              position: absolute;
              left: 0;
              top:0;
            }
            .name{
              font-weight: 500;
              font-size: 14px;
              color:#4a4a4a;
              padding: 10px 0 5px 0;
              .svg-icon{
                width: 15px!important;
                margin-left: 10px;
              }
              span{
                font-size: 12px;
                color:#999;
              }
            }
            .dept{
              font-size: 12px;
              color:#999;
              padding-bottom: 8px;
            }
            .edit{
              font-size: 12px;
              font-weight: 500;
              color:#409EFF;
            }
          }
          .box{
            text-align: center;
            margin-top: 16px;
            .txt{
              font-size: 12px;
              color:#999;
              padding-bottom: 10px;
            }
            .val{
              font-size: 20px;
              color:#409EFF;
              font-weight: 500;
              .unit{
                font-size: 12px;
                color:#999;
                font-weight: 400;
              }
            }
          }
          .filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 10px 0 0 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .el-pagination{
            width: 100%;
            margin-top: 20px;
            padding-left: 10px;
          }
          .el-tab-pane{
            min-height: 412px;
          }
          .integral-list{
            width: 100%;
            position: relative;
            margin: 10px 0 0 0;
            padding: 0;
            list-style: none;
            li{
              width: 100%;
              padding: 14px 100px 14px 10px;
              border-bottom: 1px solid #f5f7fa;
              cursor: pointer;
              border-radius: 2px;
              position: relative;
              .remark{
                width: 100%;
                position: relative;
                font-size: 13px;
                padding: 6px 0 ;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              }
              .time{
                font-size: 12px;
                color:#999;
              }
              .num{
                position: absolute;
                right: 20px;
                top: 16px;
                font-size: 20px;
                color:#409EFF;
                &.less{
                  color:#F56C6C;
                }
              }
              &:last-child{
                border-bottom:0;
              }
              &:hover{
                background: #f5f7fa;
              }
            }
          }
          .course-list{
            width: 100%;
            padding: 0;
            margin: 0;
            position: relative;
            li{
              list-style: none;
              position: relative;
              padding-left: 95px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              /*border-bottom: 1px solid #f5f7fa;*/
              border-radius: 2px;
              .course-img{
                border-radius: 2px;
                width: 75px;
                height: 42px;
                background-position: center center;
                background-size: cover;
                background-repeat: no-repeat;
                position: absolute;
                top:15px;
                left: 10px;
              }
              .course-info{
                width: 100%;
                position: relative;
                height: 42px;
                .course-name{
                  width: 100%;
                  padding-right: 115px;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  white-space: nowrap;
                }
                .course-chapter{
                  font-size: 12px;
                  color:#999999;
                  padding-top: 6px;
                  width: 100%;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  white-space: nowrap;
                }
                .course-cache{
                  position: absolute;
                  font-size: 12px;
                  right: 10px;
                  top:10px;
                  color:#999;
                  .val{
                    color:#409EFF;
                    font-size: 20px;
                    margin: 0 4px;
                  }
                }
              }
              &:hover{
                background: #f5f7fa;
                .course-name{
                  color: #409EFF;
                }
              }
              &:last-child{
                border-bottom: 0;
              }
            }
          }
          .collect-list{
            width: 100%;
            padding: 0;
            margin: 0;
            position: relative;
            li{
              list-style: none;
              position: relative;
              padding-left: 95px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              .collect-img{
                border-radius: 2px;
                width: 75px;
                height: 42px;
                background-position: center center;
                background-size: cover;
                background-repeat: no-repeat;
                position: absolute;
                top:15px;
                left: 10px;
              }
              .collect-info{
                width: 100%;
                position: relative;
                height: 42px;
                .collect-name{
                  width: 100%;
                  padding-right: 115px;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  white-space: nowrap;
                }
                .collect-desc{
                  font-size: 12px;
                  color:#999999;
                  padding-top: 6px;
                  width: 100%;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  white-space: nowrap;
                  .tag{
                    margin-right: 20px;
                    &:last-child{
                      margin-right: 0;
                    }
                  }
                }
                .el-button{
                  position: absolute;
                  right: 10px;
                  top:6px;
                }
              }
              &:hover{
                background: #f5f7fa;
                .collect-name{
                  color: #409EFF;
                }
              }
            }
          }
          .integral-lottery{
            height: 120px;
            .banner-item{
              border-radius: 2px;
              width: 100%;
              height: 120px;
              background-position: center center;
              background-size: cover;
              background-repeat: no-repeat;
            }
          }
          .goods-list{
            width: 100%;
            padding: 0;
            margin: 20px 0 0 0;
            position: relative;
            li{
              list-style: none;
              position: relative;
              padding-left: 90px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-bottom: 1px solid #f5f7fa;
              border-radius: 2px;
              .goods-img{
                border-radius: 2px;
                width: 70px;
                height: 70px;
                background-position: center center;
                background-size: cover;
                background-repeat: no-repeat;
                position: absolute;
                top:10px;
                left: 10px;
              }
              .goods-name{
                padding-top: 6px;
                width: 100%;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              }
              .goods-desc{
                font-size: 12px;
                color:#999999;
                padding-top: 6px;
                width: 100%;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              }
              .goods-price{
                font-size: 13px;
                color:#F56C6C;
                width: 100%;
                padding-top: 4px;
                span{
                  font-size: 11px;
                  color:#999;
                  margin-left: 4px;
                }
              }
              &:hover{
                background: #f5f7fa;
                .goods-name{
                  color: #409EFF;
                }
              }
              &:last-child{
                border-bottom: 0;
              }
            }
          }
        }
      }
    }
  }
}
.el-table::before{
  height: 0;
}
</style>
